<template>
    <Multiselect
        v-model="selected"
        :options="bankAccounts"
        tracked-by="uuid"
        class="bank-account-picker"
        placeholder="Velg bankkonto"
        :allow-empty="true"
        @select="bankAccountSelected"
    >
        <template #singleLabel="{option}">
            <div class="flex justify-between text-sm">
                <div>
                    {{ option.name || 'Mangler navn' }}
                </div>
                <div>
                    {{ formatBankAccountNo(option.bban) }}
                </div>
            </div>
        </template>
        <template #option="{option}">
            <div class="grid grid-cols-3">
                <div>
                    {{ option.name || 'Mangler navn' }}
                </div>
                <div>
                    {{ formatBankAccountNo(option.bban) }}
                </div>
            </div>
        </template>
        <template #noResult="{}">Ingen bankkonto funnet</template>
    </Multiselect>
</template>

<script setup lang="ts">
import {formatBankAccountNo} from '@/bank/bank-account.service'
import Multiselect from 'vue-multiselect'
import {RichBankAccount} from '@/bank/bank.types'
defineProps({
    bankAccounts: {
        type: Array as () => RichBankAccount[],
        required: true
    }
})

const selected = defineModel<RichBankAccount>()

const emit = defineEmits(['onBankAccountSelected'])
const bankAccountSelected = () => emit('onBankAccountSelected', selected?.value?.bban)

</script>

<style scoped src="vue-multiselect/dist/vue-multiselect.css"></style>

<style>
@reference "@/index.css";
@reference "tailwindcss";

.bank-account-picker {
    &.multiselect {
        @apply bg-base-100 border-none text-base-content text-sm;
    }

    .multiselect__tags {
        @apply bg-base-100 border-none;
    }

    .multiselect__content {
        @apply bg-base-100 py-2;
    }

    .multiselect__option {
        @apply hover:bg-base-200;
    }

    .multiselect__option--highlight {
        @apply bg-base-200;
    }

    .multiselect__option--selected {
        @apply bg-base-100 text-base-content;
    }

    .multiselect__input, .multiselect__single, .multiselect__input::placeholder {
        @apply bg-base-100 text-base-content;
    }

    .multiselect__content-wrapper {
        @apply shadow-2xl border-none;
    }
}
</style>